exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".body{\n  display:-webkit-box;\n  display:-ms-flexbox;\n  display:flex; \n  max-height: 5%;\n}\n\n.header {\n  margin-right: 5%;\n}\n\n.drop {\n  background-color: #3fa7d6;\n  color: #f7f7ff;\n  text-align: center;\n  padding: 1%; \n  height: 100%;\n  width: 20%;\n}\n\n.body:hover .menu {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n\n.dropItem {\n  background-color: #3fa7d6;\n  color: #f7f7ff;\n  border-bottom: 1px solid white;\n  border-left: 1px solid white;\n  padding: 6px;\n  text-align: center;\n}\n\n.dropItem:hover{\n  opacity: .6;\n}\n\n.menu {\n  display: none;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n}\n\nspan{\n  font-size: 30px;\n  margin-top: -.2%;\n  color: #3fa7d6;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/ericzayas/Documents/relativePitch/src/app/components/challenge-select/challenge-select.component.css
// module id = ../../../../../src/app/components/challenge-select/challenge-select.component.css
// module chunks = main